export default __webpack_public_path__ + "static/media/5.e7baea9b.png";